/**
 * @generated SignedSource<<3e9f4fc81aad4dfdd2fd435e415eb72b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExternalProjectBulkImport_integration$data = {
  readonly active: boolean;
  readonly ext_projects: ReadonlyArray<{
    readonly id: number;
    readonly " $fragmentSpreads": FragmentRefs<"IntegrationImportProjectsTable_ext_project">;
  }>;
  readonly id: number;
  readonly integration_syncs: ReadonlyArray<{
    readonly finished_at: any | null | undefined;
    readonly id: number;
    readonly info_messages: ReadonlyArray<string>;
    readonly started_at: any;
    readonly state: string;
  }>;
  readonly last_sync_at: any | null | undefined;
  readonly state: string;
  readonly " $fragmentSpreads": FragmentRefs<"IntegrationSyncDescription_integration">;
  readonly " $fragmentType": "ExternalProjectBulkImport_integration";
};
export type ExternalProjectBulkImport_integration$key = {
  readonly " $data"?: ExternalProjectBulkImport_integration$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExternalProjectBulkImport_integration">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExternalProjectBulkImport_integration",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "last_sync_at",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1
        },
        {
          "kind": "Literal",
          "name": "order_by",
          "value": {
            "id": "desc"
          }
        }
      ],
      "concreteType": "integration_sync",
      "kind": "LinkedField",
      "name": "integration_syncs",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "started_at",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "finished_at",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "info_messages",
          "storageKey": null
        }
      ],
      "storageKey": "integration_syncs(limit:1,order_by:{\"id\":\"desc\"})"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "order_by",
          "value": {
            "id": "asc",
            "name": "asc"
          }
        },
        {
          "kind": "Literal",
          "name": "where",
          "value": {
            "active": {
              "_eq": true
            },
            "sync": {
              "_eq": false
            }
          }
        }
      ],
      "concreteType": "ext_project",
      "kind": "LinkedField",
      "name": "ext_projects",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "IntegrationImportProjectsTable_ext_project"
        }
      ],
      "storageKey": "ext_projects(order_by:{\"id\":\"asc\",\"name\":\"asc\"},where:{\"active\":{\"_eq\":true},\"sync\":{\"_eq\":false}})"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IntegrationSyncDescription_integration"
    }
  ],
  "type": "integration",
  "abstractKey": null
};
})();

(node as any).hash = "2f469c4c1616c116328bdcebb804e983";

export default node;
